module.exports = __webpack_public_path__ + "static/wik-b211fe702c288b689a656b4daf54bb68.png";